import React from "react";

export function getCompany() {
    return {handle: process.env.REACT_APP_COMPANY_HANDLE}
}

export const CompanyContext = React.createContext(getCompany());
export const CompanyContextProvider = CompanyContext.Provider;